import { render, staticRenderFns } from "./start_discount.page.vue?vue&type=template&id=000b8c92&"
import script from "./start_discount.page.vue?vue&type=script&setup=true&lang=js&"
export * from "./start_discount.page.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./start_discount.page.vue?vue&type=style&index=0&id=000b8c92&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports